module.exports = __webpack_public_path__ + "static/media/quots_1.d696b7bd.png";